import { useEffect, useRef, useState } from "react";
import { Modal } from "bootstrap";

export default function MaxDetailModal({ show, onClose, gameList, bet }) {
  const modalRef = useRef(null);
  const modalInstance = useRef(null);

  const [localList, setLocalList] = useState([]);
  const [search, setSearch] = useState("");

  // 모달 열릴 때 gameList 를 localList 로 복사해서 사용
  useEffect(() => {
    if (show) {
      setLocalList(gameList.map((g) => ({ ...g })));
      setSearch(""); // 검색어 초기화
    }
  }, [show, gameList]);

  const handleClose = () => modalInstance.current?.hide();

  useEffect(() => {
    if (!modalRef.current) return;

    if (show) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: true,
      });

      modalInstance.current.show();
      modalRef.current.addEventListener("hidden.bs.modal", onClose);

      return () => {
        modalRef.current?.removeEventListener("hidden.bs.modal", onClose);
      };
    }
  }, [show]);

  // 🔍 검색 필터 처리
  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearch(keyword);

    if (!keyword) {
      // 검색어 삭제 => 전체 리스트 초기화
      setLocalList(gameList.map((g) => ({ ...g })));
      return;
    }

    const filtered = gameList.filter(
      (g) =>
        g.nameKR.toLowerCase().includes(keyword) ||
        g.nameEN.toLowerCase().includes(keyword)
    );

    setLocalList(filtered.map((g) => ({ ...g })));
  };

  return (
    <div
      className="modal fade"
      id="maxDetailModal"
      tabIndex="-1"
      ref={modalRef}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{bet == 0 ? "최대 당첨금액 게임별 설정" : "최대 베팅금액 게임별 설정"}</h5>
            <button className="btn-close" onClick={handleClose}></button>
          </div>

          <div className="modal-body">
            {/* 🔍 검색창 */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="게임명 검색 (KR / EN)"
                value={search}
                onChange={handleSearch}
              />
            </div>

            <div className="card">
              <table className="table table-small-font table-bordered table-striped align-middle">
                <thead>
                  <tr>
                    <th className="text-center">게임명(KR)</th>
                    <th className="text-center">게임명(EN)</th>
                    {bet == 0 ? (
                      <th className="text-center">당첨제한 금액</th>
                    ) : (
                      <th className="text-center">베팅제한 금액</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {localList.map((game, idx) => (
                    <tr key={idx}>
                      <td className="text-center">{game.nameKR}</td>
                      <td className="text-center">{game.nameEN}</td>
                      <td className="text-center">
                        <div className="input-group btn-block">
                          <input
                            className="form-control"
                            type="text"
                            inputMode="numeric"
                            style={{ textAlign: "right" }}
                            value={bet == 0 ? game.maxi : game.bet_maxi}
                            onChange={(e) => {
                              const raw = e.target.value.replace(/[^0-9]/g, "");
                              const updated = [...localList];

                              if (bet == 0) {
                                updated[idx].maxi = raw;
                              } else {
                                updated[idx].bet_maxi = raw;
                              }

                              setLocalList(updated);
                            }}
                          />

                          <button
                            className="btn btn-sm btn-primary2"
                            onClick={() => {
                              const sendValue =
                                bet == 0 ? game.maxi : game.bet_maxi;
                              game.onUpdate?.(sendValue);
                            }}
                          >
                            <i className="fas fa-edit"></i> 수정
                          </button>

                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => game.onReset?.()}
                          >
                            <i className="fas fa-redo-alt"></i> 초기화
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
